import { gql } from '@apollo/client';
import { EntityNoteFragment } from '../fragments/EntityNoteFragment';
/**
 * @const UpdateEntityNoteMutation
 * @since 1.0.0
 */
export const UpdateEntityNoteMutation = gql `
  mutation UpdateEntityNoteMutation($input: UpdateEntityNoteInput!) {
    updateEntityNote(input: $input) {
      ...EntityNoteFragment
    }
  }

  ${EntityNoteFragment}
`;
